import * as Sentry from '@sentry/react'
import { CaptureConsole as CaptureConsoleIntegration } from '@sentry/integrations'
import { ENV, SENTRY_DSN, SENTRY_RELEASE } from 'constants/index'
import { scrubUrl } from 'utils/scrubUrl'

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,

    integrations: [
      new CaptureConsoleIntegration({
        levels: ['warn', 'error'],
      }),
    ],

    tracesSampleRate: 0,
    profilesSampleRate: 0,
    attachStacktrace: true,
    beforeSend(event) {
      // logError/logWarn already reported this one; see utils/log.js.
      if (event.tags?.console_copy) return null

      if (event.request) {
        event.request.url = scrubUrl(event.request.url)
        if (event.request.headers?.Referer) {
          event.request.headers.Referer = scrubUrl(event.request.headers.Referer)
        }
      }
      return event
    },
    beforeBreadcrumb(breadcrumb) {
      const { data } = breadcrumb
      if (data) {
        if (breadcrumb.category === 'navigation') {
          data.from = scrubUrl(data.from)
          data.to = scrubUrl(data.to)
        } else if (data.url) {
          data.url = scrubUrl(data.url)
        }
      }
      return breadcrumb
    },

    release: `${SENTRY_RELEASE}`,
    environment: ENV,
  })
}
